import { createLogger } from '@/services/logger/logger';
import { tracingService } from '@/services/tracing/tracing-service';
import { CallEventLevel, CallEventName } from '@/services/tracing/types';
import { useVonageClient } from '../../vonage-client-provider';
import { serializeError } from '../error-utils';
import { useVoiceCallState } from '../voice-call-container';

const log = createLogger('Dtmf', ['calls']);

export const useDtmf = () => {
  const [call] = useVoiceCallState();
  const vonageClient = useVonageClient();

  const sendDtmf = async (value: string) => {
    if (!call.callId) {
      return;
    }

    log.info('DTMF attempt', {
      callId: call.callId,
      timestamp: Date.now(),
    });
    tracingService.trackEvent(CallEventName.AttemptKeypad, CallEventLevel.Info, {
      deviceLegId: call.callId,
    });

    try {
      await vonageClient.sendDTMF(call.callId, value);
    } catch (error) {
      log.error('DTMF failed', {
        callId: call.callId,
        ...serializeError(error),
        timestamp: Date.now(),
      });
      tracingService.trackEvent(CallEventName.VonageError, CallEventLevel.Error, {
        deviceLegId: call.callId,
        errorMessage: error instanceof Error ? error.message : String(error),
      });
      throw error;
    }
  };

  return { sendDtmf };
};
